import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Textarea } from '../../ui/textarea';
import { Button } from '../../ui/button';
import { useAuth } from '../../../context/AuthContext';
import { isFullAdmin } from '../../tax/taxDisplay';
import { API, auth, err } from './invoiceApi';

// Staff-only notes; Admins can append a note even after payment (amounts and tax stay untouched)
export const InternalNotes = ({ invoice, token, onAdded }) => {
  const { user } = useAuth();
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const add = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/admin/invoices/${invoice.id}/internal-note`, { note }, auth(token));
      toast.success('Internal note added'); setNote(''); onAdded();
    } catch (e) { toast.error(err(e, 'Could not add note')); } finally { setSaving(false); }
  };
  if (!invoice.internal_notes && !isFullAdmin(user)) return null;
  return (
    <div className="mx-6 mb-6 border rounded-md p-4 bg-amber-50/40" data-testid="invoice-internal-notes">
      <p className="text-xs font-semibold uppercase tracking-wider text-neutral-500 mb-2">Internal notes (staff only)</p>
      {invoice.internal_notes && <pre className="whitespace-pre-wrap text-sm text-neutral-700 font-sans mb-3" data-testid="invoice-internal-notes-text">{invoice.internal_notes}</pre>}
      {isFullAdmin(user) && (
        <div className="flex gap-2 items-end">
          <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Add a dated internal note" data-testid="invoice-internal-note-input" />
          <Button size="sm" disabled={!note.trim() || saving} onClick={add} data-testid="invoice-internal-note-add">Add note</Button>
        </div>
      )}
    </div>
  );
};
